<template>
    <div id="AssetMaintananceList">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Asset Maintenance List
                        <data-table-column-config :moduleName="'assetMainList'"></data-table-column-config>
                        <router-link v-if="canAddMain == true" class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'AssetMaintananceReportingStandardCreate'}" > <i class="hi-icon icon-flAdd"> </i> Add</router-link>
                    </div>
                    <div class="admin-page-content customer-detail">
                        <data-table-filter-config :moduleName="'assetMainList'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                                    ref="listAssetMaintananceTable"
                                    mode="remote"
                                    title="Asset Maintanance"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: true,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_maintanance_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <router-link v-if="canUpdateMain" title="Edit Asset Maintanance" class="glyphicon glyphicon-edit" v-bind:to="{name: 'AssetMaintananceReportingStandardEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="asset_maintanance_value == true" id="deleteMetricTypeBtn" v-on:click.prevent="assetMaintananceDelete" class="btn btn-success waves-effect">Delete</button>
                                    </div>
                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "AssetMaintananceList",
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'System',
                    field: 'system',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "System", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assembly',
                    field: 'assembly',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assembly", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Part',
                    field: 'part',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Part", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_maintanance_value: false,
            loading:false,
            canUpdateMain:false,
            canAddMain:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_maintanance_reporting_standards') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset_maintanance_reporting_standards') {
                            self.asset_maintanance_value = true;
                        }
                        if (permissions[i].name == 'add_asset_maintanance_reporting_standards') {
                            self.canAddMain = true;
                            self.canUpdateMain = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetMaintananceTable.unselectAllInternal();
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('uom');
                    field:('type');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.uom || filters.type ) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetmaintanance/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            assetMaintananceDelete() {
                var data = this.$refs['listAssetMaintananceTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetMaintananceTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Asset Maintanance? ')) {
                    self.loading = true;
                    $("#deleteMetricTypeBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/assetmaintanance/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteMetricTypeBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                               self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/AssetMaintananceReportingStandardList.vue